<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Clave de retiro</b-card-header>
      <b-card-body class="text-center">
        <div>
        <label style="font-size:20px;">Informá este número de token cuando<br>necesites extraer efectivo</label>
        </div>
        <div>
          <img src="@/assets/Token.png" style="max-height:150;max-width:150px;" />
        </div>
        <label style="font-size:30px;">{{response.TokenValue}}</label>

        <radial-progress-bar
          :diameter="200"
          :completed-steps="completedSteps"
          :total-steps="totalSteps"
          :startColor="colorStart"
          :stopColor="colorStart"
          :innerStrokeColor="colorFondo"
          animateSpeed="0"          
        >
          <label style="font-size:30px;">{{tiempoQueda}}</label>
        </radial-progress-bar>
        <div>
          <div>Si el token falló podes generar otro</div>
          <div>
            <button @click="newToken" class="btn btn-success" id="btnGenerarNuevoToken">Generar Nuevo</button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
 .radial-progress-container {
  height: 100% !important;
  width: 100% !important;
} 
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";

import notificationHelpers from "@/helpers/notificationHelpers";
import RadialProgressBar from "vue-radial-progress";

// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import { setInterval, clearInterval } from "timers";
import { constants } from "crypto";

import store from "@/store";

export default {
  components: {
    RadialProgressBar
  },
  data() {
    return {
      response: {
        TokenValue: "--- ---",
        ExpirationDate: "",
        SecondsLeft: 0
      },
      completedSteps: 0,
      totalSteps: 0,
      colorStart: "#ff5955",
      colorFondo: "#939393",
      tiempoQueda: "00:00",
      timer: null
    };
  },
  methods: {
    timeleft(context) {
      return Number(context.totalSteps - context.completedSteps);
    },
    newToken() {
      let context = this;
      context.getToken(context, true);
    },
    iniciarTimer(context) {
      clearInterval(context.timer);
      context.timer = setInterval(() => {
        context.completedSteps = Math.floor(context.completedSteps + 1);
        if (context.completedSteps == context.totalSteps) {
          clearInterval(context.timer);
          this.newToken(context);
        }else{
        var queda = context.timeleft(context);
        let mins = Math.floor(
          ((queda * 1000) % (1000 * 60 * 60)) / (1000 * 60)
        );
        let secs = Math.floor(((queda * 1000) % (1000 * 60)) / 1000);
        context.tiempoQueda =
          ("0" + mins).slice(-2) + ":" + ("0" + secs).slice(-2);
          }
      }, 1000);
    },
    getToken(context, getNew) {
      axiosHelpers.axiosPost(
        "Account/GetNewCashoutToken",
        { NewToken: getNew },
        context,
        function(data) {
          context.response = data.ResponseVM;
          context.totalSteps = data.ResponseVM.TotalMinutes * 60;
          context.completedSteps =            context.totalSteps - context.response.SecondsLeft;
          context.iniciarTimer(context);
        }
      );
    },
    async checkAccountIdentityValidated(context) {
      var req = { AccountID: store.getters.accountID };
      axiosHelpers.axiosPost("Account/CheckAccountIdentityValidated", req , context,
        function(data) {
          if(!data.ResponseVM.WasValidated) {
            context.$router.push("verificacionidentidad");
          } else {
            context.getToken(context, false);
          }
        }
      );
    }
  },
  beforeMount: function() {
    this.checkAccountIdentityValidated(this);
  }
};
</script>